import { render, staticRenderFns } from "./qanda-card.vue?vue&type=template&id=1670a19a&scoped=true&"
import script from "./qanda-card.vue?vue&type=script&lang=js&"
export * from "./qanda-card.vue?vue&type=script&lang=js&"
import style0 from "./qanda-card.vue?vue&type=style&index=0&id=1670a19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670a19a",
  null
  
)

export default component.exports